/* * 地图图层点击事件 -环境详情 * @module components/mapbase/MapdetailTip * @desc 用于地图弹框显示 *
@author zhaoting * @date 2019年12月19日 * @param {Boolean} [modal2] - 是否显示 * @param {Object}
[environmentArr] - 详细信息 */
<script>
export default {
  name: 'MapdetailTip',
  components: {},
  props: {
    environmentArr: {
      type: Object,
      default: '',
    },
    modal2: {
      type: Boolean,
      default: '',
    },
  },
  data() {
    return {
      map: {},
    };
  },
  mounted() {
    // this.initMapClick();
    //    this.initInfo();
  },
  created() {
    //    this.configmap = config.map;
  },
  methods: {
    initInfo() {},
    videoRemoveMenusClick() {
      this.$emit('childFn', false);
    },
  },
};
</script>

<template>
  <div class="mapdetail">
    <!--<Modal-->
    <!--v-model="modal2"-->
    <!--title="环境情况"-->
    <!--@on-ok="ok">-->
    <!--<table class="table" style="width: 100%">-->
    <!--<tr v-for="(value,key,index) in environmentArr">-->
    <!--<td style='text-align: center'>{{key}}</td>-->
    <!--<td style='text-align: center'>{{value}}</td>-->
    <!--</tr>-->
    <!--</table>-->
    <!--</Modal>-->

    <!--/*环境信息 */-->
    <div
      v-show="modal2"
      id="tab-environment"
      class="videolayer tool-main dragMove"
      style="width: 300px;right: 10px;bottom: 40px; height: 380px;"
    >
      <div class="title">
        <span class="fa fa-cloud">&nbsp;环境信息</span>
        <span
          style="cursor: pointer; position: absolute; right: 10px; font-size: 16px;"
          class="rmLayer"
          @click.stop="videoRemoveMenusClick()"
        >
          <Icon type="md-close" />
        </span>
      </div>
      <div
        id="content-environment"
        class="content smalltable"
        style="color: #000000;    height: 330px;overflow: auto;"
      >
        <!--<ul>-->
        <!--<li v-for="(value,key,index) in environmentArr">-->
        <!--<span>{{key}}:</span>-->
        <!--<span>{{value}}</span>-->
        <!--</li>-->
        <!--</ul>-->
        <table 
class="table" style="width: 100%">
          <tr v-for="(value, key, index) in environmentArr">
            <td style="text-align: center">{{ key }}</td>
            <td style="text-align: center">{{ value }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
.tool-main {
  background-color: rgba(255, 255, 255, 0.8);
  position: absolute;
  /* right: 70px; */
  font-size: 12px;
  z-index: 999;
  /* display: none; */
  bottom: 0;
  /*color: white;*/
  border-width: 1px;
  border-style: solid;
  border-color: #227446;
}
.videolayer {
  height: 300px;
  /*top: 190px;*/
  right: 35%;
  /*left: 20px;*/
  /*background-color: rgba(255, 255, 255, 0.8);*/
  background-color: #ffffff;
  position: absolute;
  font-size: 12px;
  z-index: 999;
  /* display: none; */
  bottom: 60px;
  color: white;
  border-width: 1px;
  border-style: solid;
  border-color: #227446;
}

.videolayer .title {
  background-color: rgb(54, 154, 1);
  height: 40px;
  line-height: 40px;
  padding-left: 15px;
  font-weight: bold;
}
.videolayer .mp_head2 {
  width: 100%;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
.smalltable {
  box-sizing: border-box;
}
.smalltable .table {
  width: 100%;
}
.smalltable .table tr th {
  border-top: none;
  border-bottom: 1px dashed #dce7f1;
  font-weight: bold;
  line-height: 1;
  font-size: 14px;
  padding: 16px 8px;
  color: #333;
}
.smalltable .table tr td {
  border-top: none;
  border-bottom: 1px dashed #dce7f1;
  line-height: 1;
  font-size: 14px;
  padding: 16px 8px;
  color: #666;
}
.smalltable .table tr th:first-child,
.smalltable .table tr td:first-child {
  padding-left: 20px;
}
.smalltable .table tr:hover th,
.smalltable .table tr:hover td {
  background: #f1f9ff;
}
</style>



// WEBPACK FOOTER //
// src/components/mapbase/MapdetailTip.vue